<div class="summary-container">
    @if (processors.length > 0) {
        <div class="processor-summaries-container">
            @for (processor of processors; track processor) {
                <div class="processor-summary-container">
                    @if (getTotalItems(processor) > 0) {
                        <div class="processor-summary-text">
                            @if (processors.length > 1) {
                                <span class="processor-summary-label">{{ processor }} PDF Export Queue:</span>
                            } @else {
                                <span class="processor-summary-label">PDF Export Queue:</span>
                            }
                            <span class="processor-summary-details">
                                    {{ getLoginItemsCount(processor) }} of your exports in queue,
                                {{ getLoginProcessingItemsCount(processor) }} processing
                                    ({{ getTotalItems(processor) }} total in queue)
                                </span>
                        </div>

                        <div class="segmented-progress-bar">
                            @for (position of getTotalItems(processor) | range; track position) {
                                <div class="progress-segment"
                                     [class.user-segment]="isUserItemPosition(processor, position)"
                                     [class.processing]="isProcessingItem(processor, position)"
                                     [style.width.%]="getSegmentWidth(processor)">

                                    <div class="segment-content">
                                        <i [class]="getStatusIcon(processor, position)"></i>
                                        <span class="segment-position">{{ position + 1 }}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }

            <div class="progress-summaries-legend">
                <div class="legend-item">
                    <div class="legend-color user-segment"></div>
                    <span>Your exports</span>
                </div>
                <div class="legend-item">
                    <div class="legend-color other-segment"></div>
                    <span>Other exports</span>
                </div>
            </div>
        </div>
    }
</div>